var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_98_16394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8064 14.3185C24.0586 14.0439 24.0653 13.5694 23.821 13.2847L16.0241 4.20018C15.6516 3.76617 15.0293 4.08439 15.0293 4.7089V8.50115C12.1149 8.44685 9.92532 9.36577 8.29814 10.774C6.64552 12.2043 5.59256 14.1221 4.9437 15.981C4.29544 17.8382 4.04562 19.65 4.00584 20.8922C3.98622 21.5048 4.01653 22.0104 4.08934 22.3193C4.10795 22.3983 4.13309 22.4811 4.16924 22.5544C4.20105 22.6189 4.26836 22.7312 4.39066 22.7781C4.53781 22.8345 4.66271 22.7621 4.7351 22.6872C4.80044 22.6195 4.84434 22.5324 4.87473 22.4591L4.87858 22.4498L4.88169 22.4411L4.88198 22.4402L4.88273 22.4382L4.88872 22.4225C4.89451 22.4076 4.90393 22.3839 4.91726 22.3524C4.94392 22.2893 4.9862 22.1949 5.04633 22.0758C5.16661 21.8376 5.35809 21.5013 5.63856 21.1209C6.19879 20.3611 7.11586 19.4229 8.53599 18.7381C9.34435 18.3483 10.6918 18.1709 12.0128 18.1422C13.2735 18.1148 14.4493 18.2235 15.0293 18.3777V22.2811C15.0293 22.8942 15.6321 23.2171 16.0095 22.8062L23.8064 14.3185Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4045 13.3088C21.9677 12.5195 21.4045 11.3937 21.4045 11.3937L20.4326 9.33937L16.0241 4.20018C15.6516 3.76617 15.0293 4.08439 15.0293 4.7089V8.50115C12.1149 8.44685 9.92532 9.36577 8.29814 10.774C6.64552 12.2043 5.59256 14.1221 4.9437 15.981C4.29544 17.8382 4.04562 19.65 4.00584 20.8922C3.98622 21.5048 4.01653 22.0104 4.08934 22.3193C4.10795 22.3983 4.13309 22.4811 4.16924 22.5544C4.20105 22.6189 4.26836 22.7312 4.39066 22.7781C4.53781 22.8345 4.66271 22.7621 4.7351 22.6872C4.80044 22.6195 4.84434 22.5324 4.87473 22.4591L4.87858 22.4498L4.88169 22.4411L4.88198 22.4402L4.88273 22.4382L4.88872 22.4225C4.89451 22.4076 4.90393 22.3839 4.91726 22.3524C4.94392 22.2893 4.9862 22.1949 5.04633 22.0758C5.16661 21.8376 5.35809 21.5013 5.63856 21.1209C6.19879 20.3611 9.30727 17.7022 11.0679 16.6409C12.5351 15.5797 15.0293 14.8722 15.0293 14.8722V19.1172C15.0293 19.7303 15.6321 20.0531 16.0095 19.6423L21.4045 13.3088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_98_16394",
    x: 0,
    y: 0.33,
    width: 28,
    height: 26.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_98_16394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_98_16394",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsShareIcon);
export default __webpack_public_path__ + "static/media/es_share_icon.1ab17700be79d35dffdf189f8453b815.svg";
export { ForwardRef as ReactComponent };